import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import {
  requestAuth,
  whatsAppReq,
  requestAuthGoogle,
  requestAuthDemo,
} from "../../store/auth/auth.thunks";
import { requestBalance } from "../../store/balance/balance.thunks";
import { requestRecaptcha } from "../../store/recaptcha/recaptcha.thunks";
import { getRecaptchaSuccess } from "../../store/recaptcha/recaptcha.slice";
import { setVersion } from "../../store/version/version.slice";
import {
  postNumberSignUp,
  resendOTP,
  verifyOTP,
  postCheckPromo,
  getPromotionsList,
  CreateUserOTP,
  VerifyRefferalCode,
  registerNew,
  forgotPasswordOtp,
  resendForgotOTP,
  verifyForgotOTP,
  resetPassword,
} from "../../store/signUp/signUp.thunks";
import {
  postNumberForgotPassword,
  verifyForgotPasswordOTP,
} from "../../store/forgotPassword/forgotPassword.thunks";
import {
  setIsDetailedPromo,
  setIsTermCondition,
  setPromoInfo,
  setReferCode,
} from "../../store/signUp/signUp.slice";
import { setLoginNew, setTab } from "../../store/LoginNew/loginNew.slice";
import {
  setIsNavigationID,
  setIsNavigationName,
} from "../../store/navigationHeaderMenu/navigationHeaderMenu.slice";
import {
  setCasinoType,
  setSelectedProvider,
} from "../../store/casinoprovider/casinoprovider.slice";
import { clearNavigationData } from "../../store/loginNavigation/LoginNavigation.slice";
import { openSlotCasinoPopUp } from "../../store/slotCasinoPopUp/slotCasinoPopUp.slice";

export const connectLoginPopUp = (wrappedProps) => (component) => {
  function mapStateToProps(state) {
    return {
      auth: state.auth,
      recaptcha: state.recaptcha,
      version: state.version,
      B2C: state.B2C,
      isDetailedPromo: state.signUp.isDetailedPromo,
      isTermCondition: state.signUp.isTermCondition,
      promoInfo: state.signUp.promoInfo,
      tab: state.loginNew.tab,
      promoListStore: state.signUp.promoListStore,
      signUp: state.signUp,
      elementsParams: state.elementsParams,
      loginNavigation: state.loginNavigation,
      logo: state.logo,
    };
  }

  function mapDispatchToProps(dispatch) {
    const actions = {
      requestAuth,
      requestRecaptcha,
      getRecaptchaSuccess,
      setVersion,
      requestBalance,
      postNumberSignUp,
      resendOTP,
      verifyOTP,
      postCheckPromo,
      getPromotionsList,
      setIsDetailedPromo,
      setPromoInfo,
      postNumberForgotPassword,
      verifyForgotPasswordOTP,
      setTab,
      setIsTermCondition,
      setLoginNew,
      CreateUserOTP,
      VerifyRefferalCode,
      whatsAppReq,
      requestAuthGoogle,
      setIsNavigationID,
      setIsNavigationName,
      setCasinoType,
      setSelectedProvider,
      openSlotCasinoPopUp,
      clearNavigationData,
      setReferCode,
      requestAuthDemo,
      registerNew,
      forgotPasswordOtp,
      resendForgotOTP,
      verifyForgotOTP,
      resetPassword,
    };

    return { actions: bindActionCreators(actions, dispatch) };
  }

  return connect(mapStateToProps, mapDispatchToProps)(component);
};
